var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBanksCards = function SvgBanksCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.222 15.768-.225-1.125h-2.514l-.4 1.117-2.015.004q1.943-4.669 2.884-6.917c.164-.392.455-.592.884-.589q.492.004 1.606.001L24 15.765zm-2.174-2.666h1.621l-.605-2.82zM7.062 8.257l2.026.002-3.132 7.51-2.051-.002a951 951 0 0 1-1.528-5.956c-.1-.396-.298-.673-.679-.804Q1.187 8.832 0 8.466v-.207h3.237c.56 0 .887.271.992.827q.159.836.8 4.254zm4.81.002-1.601 7.509-1.929-.003L9.94 8.257zm3.91-.139c.577 0 1.304.18 1.722.346l-.338 1.556c-.378-.152-1-.357-1.523-.35-.76.013-1.23.332-1.23.638 0 .498.816.749 1.656 1.293.958.62 1.085 1.177 1.073 1.783-.013 1.255-1.073 2.494-3.309 2.494-1.02-.015-1.388-.1-2.22-.396l.352-1.624c.847.354 1.206.467 1.93.467.663 0 1.232-.268 1.237-.735.004-.332-.2-.497-.944-.907s-1.788-.979-1.774-2.122c.017-1.462 1.402-2.443 3.368-2.443"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#banks_cards_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M47.245 17.831h-6.49V6.168h6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M41.167 12A7.4 7.4 0 0 1 44 6.169a7.417 7.417 0 1 0-.001 11.662A7.4 7.4 0 0 1 41.167 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M56 12a7.416 7.416 0 0 1-12 5.83A7.4 7.4 0 0 0 46.833 12 7.4 7.4 0 0 0 44 6.169a7.417 7.417 0 0 1 12 5.83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "banks_cards_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 0h24v24H32z"
  })))));
};
export default SvgBanksCards;